module.exports = __webpack_public_path__ + "static/media/background_SPA.62887815.jpg";